import { render } from "./Users.vue?vue&type=template&id=07ed4108&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=07ed4108&scoped=true&lang=css"

import exportComponent from "C:\\Users\\piyus\\OneDrive\\Documents\\Github\\admin-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ed4108"]])

export default __exports__